<script setup lang="ts">
import i18n, { defaultAvailableLangs } from '@/locales/i18n'
import {
    EContextProvider,
    EEnv,
    EProviders,
    type VersionItem
} from '@rfc/rfc-components-library/types'
import { provide } from 'vue'
import { useI18n } from 'vue-i18n'
import { useRoute, useRouter } from 'vue-router'
import { useStore } from 'vuex'
import AdminProvider from './AdminProvider.vue'
import DetectionContextProvider from './DetectionContextProvider.vue'
import DeviceContextProvider from './DeviceContextProvider.vue'
import MenuProvider from './MenuProvider.vue'
import MyAccountProvider from './MyAccountProvider.vue'
import SocketContextProvider from './SocketContextProvider.vue'
import TagProducerContextProvider from './TagProducerContextProvider.vue'
import ThemeContextProvider from './ThemeContextProvider.vue'
import UserContextProvider from './UserContextProvider.vue'

const router = useRouter()
const route = useRoute()
const store = useStore()
const { t, te } = useI18n()
const availableLangs = defaultAvailableLangs
// VITE_BUILD_ENV/VITE_BUILD_VERSION sont figés au build par la CI (voir Dockerfile).
// import.meta.env.NODE_ENV n'existe pas sous Vite, et VITE_CURRENT_VERSION est figé à 0.0.1
// dans les .env versionnés : il ne sert que de repli hors CI.
const version = {
    env: import.meta.env.VITE_BUILD_ENV as EEnv,
    version: import.meta.env.VITE_BUILD_VERSION || import.meta.env.VITE_CURRENT_VERSION
}

provide(EProviders.GLOBAL, {
    router,
    route,
    store,
    t,
    te,
    i18n,
    availableLangs
})

provide<VersionItem>(EContextProvider.VERSION, version)
</script>

<template>
    <DeviceContextProvider>
        <AdminProvider>
            <MyAccountProvider>
                <SocketContextProvider>
                    <UserContextProvider>
                        <ThemeContextProvider>
                            <TagProducerContextProvider>
                                <DetectionContextProvider>
                                    <MenuProvider>
                                        <slot />
                                    </MenuProvider>
                                </DetectionContextProvider>
                            </TagProducerContextProvider>
                        </ThemeContextProvider>
                    </UserContextProvider>
                </SocketContextProvider>
            </MyAccountProvider>
        </AdminProvider>
    </DeviceContextProvider>
</template>
